import React from "react";
import '../index.css';
import Header from '../components/Header';
import Footer from "../components/Footer"; 
import homebanner from "../assets/home-banner.png"; 
import Pagetitlesection from "../components/pagetitlesection";

function About() {
  return (
    <>
      <Header />
      <div className="page-body-container">
        <Pagetitlesection title="About Us" backgroundImage={homebanner} />

      <div className="md:container mx-auto px-6 sm:px-6 py-10">
 <div className="space-y-6 text-gray-800 text-base leading-relaxed">
    <p>
      Welcome to <strong>Giffypedia</strong> – Your Personal Encyclopedia!
    </p>
    <p>
      At Giffypedia, we believe that every person has a story worth sharing. Just like Wikipedia documents facts and knowledge, Giffypedia is a unique digital space where anyone can create and share their own mini-profile – complete with basic details, photos, and achievements – All in one easy-to-access link.
    </p>
    <p>
      Whether you’re a student, artist, entrepreneur, professional, or dreamer, Giffypedia gives you the power to showcase your identity and journey with the world. It’s simple, shareable, and personal – your very own digital card that travels with you wherever you go.
    </p>
    <p>
      Our mission is to connect people through their stories, make networking effortless, and build a community where recognition starts with representation.
    </p>
    <p>
      Join the Giffypedia movement – because you deserve to be seen, known, and remembered.
    </p>
  </div>
  <br>
  </br>
    <br>
  </br>

  <div className="flex flex-col md:flex-row gap-10">
    <div className="md:w-1/2 bg-[#ef4b3a0a] rounded-lg p-6 shadow-md hover:shadow-lg transition-shadow duration-300">
      <h3 className="text-2xl font-semibold text-primarycolor mb-5 border-b-2 border-primarycolor inline-block pb-2">
        Mission Statement
      </h3>
      <ul className="list-outside text-base leading-relaxed space-y-3">
        <li>
          Our mission at Giffypedia is to empower individuals by giving them a space to present their identity, achievements, and passions in a simple, accessible digital format. We aim to make personal profiling easy, shareable, and meaningful – enabling people to connect, inspire, and be recognized.
        </li>
      </ul>
    </div>

    <div className="md:w-1/2 bg-[#ef4b3a0a] rounded-lg p-6 shadow-md hover:shadow-lg transition-shadow duration-300">
      <h3 className="text-2xl font-semibold text-primarycolor mb-5 border-b-2 border-primarycolor inline-block pb-2">
        Vision Statement
      </h3>
      <ul className="text-base leading-relaxed space-y-3">
        <li>
          We envision a world where every individual has a digital presence that truly represents who they are – their background, talents, milestones, and uniqueness. Giffypedia aspires to be the go-to platform for personal storytelling, networking, and recognition on a global scale.
        </li>
      </ul>
    </div>
  </div>
</div>

        <Footer />
      </div>
    </>
  );
}

export default About;
